<app-title-section></app-title-section>

<div class="card p-1 reassort-detail-card">
  <div *ngIf="loading" class="text-center p-5">
    <span class="spinner-border text-primary" role="status"></span>
    <p class="text-muted mt-2 mb-0">Chargement du document…</p>
  </div>

  <ng-container *ngIf="!loading">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <label class="mb-0">
        <strong class="size20">RÉASSORT / </strong>
        <span class="text-muted size20">{{ numDocument }}</span>
      </label>
      <span class="badge status-badge">{{ documentStatut }}</span>
    </div>

    <div class="items mt-2">
      <div class="detail-col">
        <p class="section-title">Entrepôt destination</p>
        <hr class="section-line" />
        <div class="detail-row">
          <span class="lbl">Nom</span>
          <span class="val">{{ entrepotDestination }}</span>
        </div>
        <hr />
        <div class="detail-row">
          <span class="lbl">Code</span>
          <span class="val">{{ entrepotDestinationCode }}</span>
        </div>
        <hr />
      </div>

      <div class="detail-col flex-grow-1">
        <p class="section-title">Détails du document</p>
        <hr class="section-line" />
        <div class="detail-row">
          <span class="lbl">Date</span>
          <span class="val">{{ documentDate }}</span>
        </div>
        <hr />
        <div class="detail-row">
          <span class="lbl">Entrepôt départ</span>
          <span class="val">{{ entrepotDepart }}</span>
        </div>
        <hr />
        <div class="detail-row">
          <span class="lbl">Statut</span>
          <span class="val text-primary">{{ documentStatut }}</span>
        </div>
        <hr />
        <div class="detail-row">
          <span class="lbl">Quantité totale</span>
          <span class="val">{{ totalQty }}</span>
        </div>
        <hr />
        <div class="detail-row">
          <span class="lbl">Note</span>
          <span class="val">{{ note }}</span>
        </div>
        <hr />
      </div>
    </div>

    <div class="products-section mt-2">
      <table class="table products-table">
        <thead>
          <tr>
            <th>DÉSIGNATION / RÉFÉRENCE</th>
            <th>CODE-BARRES</th>
            <th>COULEUR / TAILLE</th>
            <th>QUANTITÉ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="ligneRows.length === 0">
            <td colspan="4" class="text-center text-muted">Aucun article</td>
          </tr>
          <tr *ngFor="let ligne of ligneRows">
            <td>
              <div class="ligne-main">{{ ligne.libelle }}</div>
              <div class="ligne-sub">{{ ligne.reference }}</div>
            </td>
            <td>{{ ligne.codeBarre }}</td>
            <td>{{ ligne.couleurTaille || '—' }}</td>
            <td>{{ ligne.quantite }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
